// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3kkqW","title":"style_title__1DTr3","subtitle":"style_subtitle__2dqel"};